import { render, staticRenderFns } from "./tableForm-b2.vue?vue&type=template&id=cf9aa234&scoped=true&"
import script from "./tableForm-b2.vue?vue&type=script&lang=js&"
export * from "./tableForm-b2.vue?vue&type=script&lang=js&"
import style0 from "./tableForm-b2.vue?vue&type=style&index=0&id=cf9aa234&prod&scoped=true&lang=css&"
import style1 from "./tableForm-b2.vue?vue&type=style&index=1&id=cf9aa234&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9aa234",
  null
  
)

export default component.exports